import PageShell from "./PageShell";
import PageHero from "./PageHero";
import Boarding from "./Boarding";
import RelatedPages from "./RelatedPages";
import PullQuote from "./PullQuote";
import { ORIG } from "../mock";

export default function BoardingPage() {
  return (
    <PageShell>
      {({ openEnquire }) => (
        <>
          <PageHero
            eyebrow="Day, Weekly & Full Boarding"
            title="A home that"
            italic="grows leaders."
            image={`${ORIG}/banner-boarding1.webp`}
            blurb="Nestled within our 20-acre campus, residential life is designed to nurture independent, principled, well-rounded young adults — in a warm and hygienic home away from home."
          />
          <Boarding onEnquire={openEnquire} />
          <PullQuote
            tone="dark"
            text="A boarding home is where children discover who they are when no one is watching — and grow into the adults the world quietly needs."
          />
          <RelatedPages current="/best-boarding-school-in-india.html" />
        </>
      )}
    </PageShell>
  );
}
